
export default {
    data(){
        return {
          VIPlist:[],
          total:0,
          currentpage:1
        }
    },
    created () {
      this.getVIP()
    },
    methods:{
      async getVIP(){
        const{data}=await this.$http.post('/shop/setmeallist',{page:this.currentpage,eachpage:10})
        if(data.status=='success'){
          this.VIPlist = data.data
          this.total = data.total
        }else{
          this.$message.error('获取套餐失败')
        }
      },
      changeAuto(val,id){
        this.VIPlist.forEach(item=>{
          if(item.id==id){
            item.auto=val
          }
        })
      },
      gotobuy(id){
        let index = this.VIPlist.findIndex(item=>{
          return item.id == id
        })
        let auto = this.VIPlist[index].auto ? true : false
        this.$router.push({path:`/center/Calculatetheprice/${id}`,query:{auto:auto,type:'setmeal'}})
      },
      handleCurrentChange(val){
        this.currentpage=val
        this.getVIP()
      }
    }
}
